var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchImgView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85542 9.74757L9.8737 9.76572L9.89374 9.7819L11.4265 11.0192L11.4606 11.0467C11.5257 11.163 11.5094 11.3143 11.4117 11.413C11.3003 11.5257 11.1234 11.5285 11.0087 11.4213L9.74943 9.97813L9.74945 9.97812L9.74687 9.97522L9.71136 9.93515C9.69453 9.91084 9.68493 9.88109 9.68493 9.84982C9.68493 9.81018 9.70033 9.77317 9.72618 9.74643C9.763 9.71103 9.81901 9.71141 9.85542 9.74757ZM5.14658 0.500347C6.3771 0.500347 7.55832 0.994379 8.43008 1.87552C9.30202 2.75684 9.79282 3.95329 9.79282 5.20196C9.79282 7.80364 7.70759 9.90356 5.14658 9.90356C2.58557 9.90356 0.500347 7.80364 0.500347 5.20196C0.500347 2.60027 2.58557 0.500347 5.14658 0.500347Z",
    stroke: "white",
    strokeWidth: 1.00069
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchImgView);
export default __webpack_public_path__ + "static/media/searchImgView.73d7dd7440fc41a8d5169b7cfda03c5f.svg";
export { ForwardRef as ReactComponent };